"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartFilled = exports.FavoritesHeartRoot = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const FavoritesHeartRoot = exports.FavoritesHeartRoot = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'inline-flex',
    fontSize: '3rem',
    height: 'fit-content',
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.primary,
      cursor: 'pointer'
    },
    '& div:first-of-type': {
      alignItems: 'center',
      display: 'flex'
    }
  }
}));
const HeartFilled = exports.HeartFilled = (0, _mui.styled)(_icons.HeartFilled)(({
  theme
}) => ({
  color: theme.palette.pink[300]
}));
